import React, { useState } from "react";
import { Card, Modal, Row, Col } from "react-bootstrap";
import * as Ai from "react-icons/ai";
import * as ReactIcons from "react-icons/gi";
import ImageSlider from "./ImageSlider";
import "./serviceCard.css"; // Import the CSS file

export default function ServiceCard({ service }) {
  const IconComponent = ReactIcons[service.icon]; // Get the icon component based on the name

  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <div onClick={handleClick}>
        <Card className="services-card">
          <Card.Body
            className="d-flex justify-content-center align-items-center flex-column "
            style={{ textAlign: "center" }}
          >
            <IconComponent size={50} color={"var(--primary"} className="mb-2" />
            <Card.Title className="fs-3 fw-bold">{service.title}</Card.Title>
            <Card.Text>{service.desc}</Card.Text>
          </Card.Body>
        </Card>
      </div>

      <Modal
        show={showModal}
        onHide={handleClose}
        size="lg" // set the size of the modal to large
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold">{service.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <ImageSlider images={service.images} />
            </Col>
            <Col md={6}>
              <p>{service.longdesc}</p>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}
